{/*import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/RecruiterAuth 1.css";
import axios from "axios";

const RecruiterOnboarding = () => {
  const navigate = useNavigate();

  const [step, setStep] = useState(1);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [error, setError] = useState("");
  const [otpError, setOtpError] = useState("");
  const [timer, setTimer] = useState(0);
  const [resendDisabled, setResendDisabled] = useState(false);
  const [isEditingPhone, setIsEditingPhone] = useState(false);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    companyName: "",
    logo: "",
    website: "",
    industry: "",
    description: "",
    address: "",
    noOfEmployees: "",
    designation: "",
  });

  const companyOptions = {
    "Techify Solutions": {
      logo: "https://via.placeholder.com/70",
      website: "https://techifysolutions.com",
      description: "Techify Solutions is a leading IT services company.",
      address: "Bangalore, India",
    },
    "EduSpark Pvt Ltd": {
      logo: "https://via.placeholder.com/70",
      website: "https://eduspark.com",
      description: "EduSpark offers innovative e-learning solutions.",
      address: "Chennai, India",
    },
    "FinGrow Capital": {
      logo: "https://via.placeholder.com/70",
      website: "https://fingrow.com",
      description: "FinGrow provides investment and financial consulting.",
      address: "Mumbai, India",
    },
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "logo" && files.length > 0) {
      const file = files[0];
      if (file.size > 2 * 1024 * 1024) {
        setError("Logo must be less than 2 MB");
        return;
      }
      const reader = new FileReader();
      reader.onload = () => setForm({ ...form, logo: reader.result });
      reader.readAsDataURL(file);
    } else if (name === "companyName") {
      const company = companyOptions[value];
      if (company) {
        setForm({
          ...form,
          companyName: value,
          logo: company.logo,
          website: company.website,
          description: company.description,
          address: company.address,
        });
      } else {
        setForm({ ...form, [name]: value });
      }
    } else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleContinue = (e) => {
    e.preventDefault();
    const name = form.name?.trim() || "";
    const email = form.email?.trim() || "";
    const phone = form.phone?.trim() || "";

    if (name !== "" && email !== "" && phone !== "") {
      setShowOtpModal(true);
      setError("");
      startOtpTimer();
    } else {
      setError("Please fill all required fields before continuing.");
    }
  };

  const startOtpTimer = () => {
    setResendDisabled(true);
    setTimer(30);
  };

  useEffect(() => {
    let countdown;
    if (resendDisabled && timer > 0) {
      countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setResendDisabled(false);
    }
    return () => clearInterval(countdown);
  }, [timer, resendDisabled]);

  const handleResendOtp = () => {
    setOtp(["", "", "", ""]);
    setOtpError("");
    startOtpTimer();
  };

  const handleOtpChange = (value, index) => {
    if (/^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      setOtpError("");
      if (value && index < otp.length - 1) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };

  const handleVerifyOtp = () => {
    const enteredOtp = otp.join("");
    if (enteredOtp === "1234") {
      setIsOtpVerified(true);
      setShowOtpModal(false);
      setStep(2);
    } else {
      setOtpError("Invalid OTP. Please try again.");
    }
  };
  

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!isOtpVerified) {
    alert("Please verify your mobile number before submitting.");
    return;
  }

  // ✅ Map frontend form field names → backend expected field names
  const payload = {
    account_type: "Company", // You can set this dynamically if needed
    hiring_for: "Your Company",
    full_name: form.name,
    email: form.email,
    contact_number: form.phone,
    company_name: form.companyName,
    company_logo: form.logo || null,
    company_website: form.website || null,
    num_employees: parseInt(form.noOfEmployees) || null,
    company_address: form.address,
    industry: form.industry,
    designation: form.designation || "",
    company_description: form.description || "",
  };

  try {
    const response = await axios.post(
      "http://127.0.0.1:8000/api/recruiter/onboard",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          // If JWT auth later added:
          // "Authorization": `Bearer ${token}`,
        },
      }
    );

    console.log("✅ Recruiter Onboard Success:", response.data);
    alert("🎉 Recruiter registration completed successfully!");
    navigate("/success");
  } catch (error) {
    console.error("❌ Onboard Error:", error.response?.data || error.message);
    const msg =
      error.response?.data?.detail || "Error onboarding recruiter. Try again.";
    alert(msg);
  }
  };
   // Arthi's code 
  {/*const handleSubmit = (e) => {
    e.preventDefault();
    if (!isOtpVerified) {
      alert("Please verify your mobile number before submitting.");
      return;
    }
    localStorage.setItem("recruiterInfo", JSON.stringify(form));
    alert("🎉 Recruiter registration completed successfully!");
    navigate("/success");
  };

  const handleBack = () => {
    setStep(1);
  };

  return (
    <div className="auth-container">
      <div className="auth-card large">
        
        <div className="step-tracker">
          <div className={`step-item ${step === 1 ? "active" : ""}`}>
            Basic Details
          </div>
          <div className="step-line" />
          <div className={`step-item ${step === 2 ? "active" : ""}`}>
            Company Details
          </div>
        </div>

        
        <div className="progress-container">
          <div
            className="progress-bar"
            style={{ width: step === 1 ? "50%" : "100%" }}
          ></div>
        </div>
        <p className="progress-text">
          Step {step} of 2 — {step === 1 ? "Basic Details" : "Company Details"}
        </p>

        {step === 1 && (
          <>
            <h2>Welcome Recruiter</h2>
            <p
              style={{
                textAlign: "center",
                color: "#555",
                marginBottom: "1rem",
              }}
            >
              Let's start by setting up your basic details
            </p>

            <form onSubmit={handleContinue}>
              <div className="form-group">
                <label>Full Name *</label>
                <input
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Official Email ID *</label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Mobile Number *</label>
                <input
                  type="tel"
                  name="phone"
                  placeholder="+91 XXXXXXXXXX"
                  value={form.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              <button type="submit" className="auth-btn">
                Continue
              </button>

              {error && <p className="error-text">{error}</p>}
            </form>
          </>
        )}

        {step === 2 && (
          <>
            <h2>Company Details</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Company Name *</label>
                <select
                  name="companyName"
                  value={form.companyName}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Company</option>
                  {Object.keys(companyOptions).map((c) => (
                    <option key={c}>{c}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label>Company Logo</label>
                <input
                  type="file"
                  name="logo"
                  accept=".png,.jpg,.jpeg"
                  onChange={handleChange}
                />
                {form.logo && (
                  <img src={form.logo} alt="Preview" className="logo-preview" />
                )}
              </div>

              <div className="form-group">
                <label>Website</label>
                <input
                  type="url"
                  name="website"
                  value={form.website}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Industry</label>
                <select
                  name="industry"
                  value={form.industry}
                  onChange={handleChange}
                >
                  <option value="">Select Industry</option>
                  <option>IT Services</option>
                  <option>Education</option>
                  <option>Finance</option>
                  <option>Manufacturing</option>
                  <option>Healthcare</option>
                  <option>Others</option>
                </select>
              </div>

              <div className="form-group">
                <label>Company Description</label>
                <textarea
                  name="description"
                  rows="3"
                  value={form.description}
                  onChange={handleChange}
                ></textarea>
              </div>

              <div className="form-group">
                <label>Company Address</label>
                <input
                  name="address"
                  value={form.address}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>No. of Employees (optional)</label>
                <input
                  name="noOfEmployees"
                  value={form.noOfEmployees}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Your Designation (optional)</label>
                <input
                  name="designation"
                  value={form.designation}
                  onChange={handleChange}
                />
              </div>

              <div style={{ display: "flex", gap: "10px", marginTop: "1rem" }}>
                <button
                  type="button"
                  className="auth-btn back-btn"
                  onClick={handleBack}
                >
                  Back
                </button>
                <button type="submit" className="auth-btn">
                  Complete Registration
                </button>
              </div>
            </form>
          </>
        )}
      </div>

      
      {showOtpModal && (
        <div className="otp-overlay active">
          <div className="otp-modal">
            <h3>Verify Mobile Number</h3>

            <div className="otp-text-line">
              <p>
                We’ve sent an OTP to{" "}
                {isEditingPhone ? (
                  <input
                    type="tel"
                    name="phone"
                    value={form.phone}
                    onChange={handleChange}
                    className="edit-phone-input"
                  />
                ) : (
                  <strong>{form.phone}</strong>
                )}
              </p>
              <button
                className="edit-btn"
                onClick={() => setIsEditingPhone(!isEditingPhone)}
              >
                ✏️
              </button>
            </div>

            <div className="otp-input-container">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-${index}`}
                  type="text"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => handleOtpChange(e.target.value, index)}
                  className="otp-box"
                />
              ))}
            </div>
            {otpError && <p className="otp-error-text">{otpError}</p>}

            <button onClick={handleVerifyOtp} className="auth-btn">
              Verify OTP
            </button>

            <div className="resend-section">
              {resendDisabled ? (
                <p className="resend-timer" style={{ color: "red" }}>
                  Resend OTP in {timer}s
                </p>
              ) : (
                <p className="resend-line">
                  Didn’t receive OTP?{" "}
                  <span className="resend-link" onClick={handleResendOtp}>
                    Resend
                  </span>
                </p>
              )}
            </div>

            <button
              onClick={() => setShowOtpModal(false)}
              className="cancel-btn"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecruiterOnboarding;

*/}

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/RecruiterAuth 1.css";
import axios from "axios";

const RecruiterOnboarding = () => {
  const navigate = useNavigate();

  const [step, setStep] = useState(1);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [error, setError] = useState("");
  const [otpError, setOtpError] = useState("");
  const [timer, setTimer] = useState(0);
  const [resendDisabled, setResendDisabled] = useState(false);
  const [isEditingPhone, setIsEditingPhone] = useState(false);
  const [isOtherCompany, setIsOtherCompany] = useState(false);

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    companyName: "",
    logo: "",
    website: "",
    industry: "",
    description: "",
    address: "",
    noOfEmployees: "",
    designation: "",
  });

  const companyOptions = {
    "Techify Solutions": {
      logo: "https://via.placeholder.com/70",
      website: "https://techifysolutions.com",
      description: "Techify Solutions is a leading IT services company.",
      address: "Bangalore, India",
    },
    "EduSpark Pvt Ltd": {
      logo: "https://via.placeholder.com/70",
      website: "https://eduspark.com",
      description: "EduSpark offers innovative e-learning solutions.",
      address: "Chennai, India",
    },
    "FinGrow Capital": {
      logo: "https://via.placeholder.com/70",
      website: "https://fingrow.com",
      description: "FinGrow provides investment and financial consulting.",
      address: "Mumbai, India",
    },
    Google: {
      logo: "https://logo.clearbit.com/google.com",
      website: "https://www.google.com",
      description: "Global technology company specializing in internet services.",
      address: "1600 Amphitheatre Parkway, Mountain View, CA",
    },
    Infosys: {
      logo: "https://logo.clearbit.com/infosys.com",
      website: "https://www.infosys.com",
      description: "IT consulting and outsourcing company based in India.",
      address: "Electronics City, Hosur Road, Bangalore, India",
    },
    Amazon: {
      logo: "https://logo.clearbit.com/amazon.com",
      website: "https://www.amazon.com",
      description: "E-commerce and cloud computing giant.",
      address: "410 Terry Ave N, Seattle, WA 98109",
    },
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "logo" && files.length > 0) {
      const file = files[0];
      if (file.size > 2 * 1024 * 1024) {
        setError("Logo must be less than 2 MB");
        return;
      }
      const reader = new FileReader();
      reader.onload = () => setForm({ ...form, logo: reader.result });
      reader.readAsDataURL(file);
    }
    else if (name === "companyName") {
      if (isOtherCompany) {
        // When user types inside textbox
        setForm({ ...form, companyName: value });
        // If user deletes text, revert to dropdown
        if (value.trim() === "") setIsOtherCompany(false);
      } else {
        // Normal dropdown selection
        if (value === "Others") {
          setIsOtherCompany(true);
          setForm({
            ...form,
            companyName: "",
            logo: "",
            website: "",
            description: "",
            address: "",
          });
        } else {
          setIsOtherCompany(false);
          const company = companyOptions[value];
          if (company) {
            setForm({
              ...form,
              companyName: value,
              logo: company.logo,
              website: company.website,
              description: company.description,
              address: company.address,
            });
          } else {
            setForm({ ...form, [name]: value });
          }
        }
      }
    }
    else {
      setForm({ ...form, [name]: value });
    }
  };

  const handleContinue = (e) => {
    e.preventDefault();
    const name = form.name?.trim() || "";
    const email = form.email?.trim() || "";
    const phone = form.phone?.trim() || "";

    if (name !== "" && email !== "" && phone !== "") {
      setShowOtpModal(true);
      setError("");
      startOtpTimer();
    } else {
      setError("Please fill all required fields before continuing.");
    }
  };

  const startOtpTimer = () => {
    setResendDisabled(true);
    setTimer(30);
  };

  useEffect(() => {
    let countdown;
    if (resendDisabled && timer > 0) {
      countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setResendDisabled(false);
    }
    return () => clearInterval(countdown);
  }, [timer, resendDisabled]);

  const handleResendOtp = () => {
    setOtp(["", "", "", ""]);
    setOtpError("");
    startOtpTimer();
  };

  const handleOtpChange = (value, index) => {
    if (/^\d*$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      setOtpError("");
      if (value && index < otp.length - 1) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };

  const handleVerifyOtp = () => {
    const enteredOtp = otp.join("");
    if (enteredOtp === "1234") {
      setIsOtpVerified(true);
      setShowOtpModal(false);
      setStep(2);
    } else {
      setOtpError("Invalid OTP. Please try again.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isOtpVerified) {
      alert("Please verify your mobile number before submitting.");
      return;
    }

    // ✅ Map frontend form field names → backend expected field names
    const payload = {
      account_type: "Company", // You can set this dynamically if needed
      hiring_for: "Your Company",
      full_name: form.name,
      email: form.email,
      contact_number: form.phone,
      company_name: form.companyName,
      company_logo: form.logo || null,
      company_website: form.website || null,
      num_employees: parseInt(form.noOfEmployees) || null,
      company_address: form.address,
      industry: form.industry,
      designation: form.designation || "",
      company_description: form.description || "",
    };

    try {
      const token = localStorage.getItem("access_token");
      const response = await axios.post(
        //"http://127.0.0.1:8000/api/recruiter/onboard",
        "http://144.91.102.67:8002/api/recruiter/onboard",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            // If JWT auth later added:
            "Authorization": `Bearer ${token}`,
          },
        }
      );

      console.log("✅ Recruiter Onboard Success:", response.data);
      alert("🎉 Recruiter registration completed successfully!");
      navigate("/success");
    } catch (error) {
      console.error("❌ Onboard Error:", error.response?.data || error.message);
      const msg =
        error.response?.data?.detail || "Error onboarding recruiter. Try again.";
      alert(msg);
    }
  };

  {/*const handleSubmit = (e) => {
    e.preventDefault();
    if (!isOtpVerified) {
      alert("Please verify your mobile number before submitting.");
      return;
    }
    localStorage.setItem("recruiterInfo", JSON.stringify(form));
    alert("🎉 Recruiter registration completed successfully!");
    navigate("/success");
  };*/}

  const handleBack = () => {
    setStep(1);
  };

  return (
    <div className="auth-container">
      <div className="auth-card large">
        {/* Step Tracker */}
        <div className="step-tracker">
          <div className={`step-item ${step === 1 ? "active" : ""}`}>
            Basic Details
          </div>
          <div className="step-line" />
          <div className={`step-item ${step === 2 ? "active" : ""}`}>
            Company Details
          </div>
        </div>

        {/* Progress Bar */}
        <div className="progress-container">
          <div
            className="progress-bar"
            style={{ width: step === 1 ? "50%" : "100%" }}
          ></div>
        </div>
        <p className="progress-text">
          Step {step} of 2 — {step === 1 ? "Basic Details" : "Company Details"}
        </p>

        {step === 1 && (
          <>
            <h2>Welcome Recruiter</h2>
            <p style={{ textAlign: "center", color: "#555", marginBottom: "1rem" }}>
              Let's start by setting up your basic details
            </p>

            <form onSubmit={handleContinue}>
              <div className="form-group">
                <label>Full Name *</label>
                <input
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Official Email ID *</label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Mobile Number *</label>
                <input
                  type="tel"
                  name="phone"
                  placeholder="+91 XXXXXXXXXX"
                  value={form.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              <button type="submit" className="auth-btn">
                Continue
              </button>

              {error && <p className="error-text">{error}</p>}
            </form>
          </>
        )}

        {step === 2 && (
          <>
            <h2>Company Details</h2>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Company Name *</label>
                {!isOtherCompany ? (
                  <select
                    name="companyName"
                    value={form.companyName}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select Company</option>
                    {Object.keys(companyOptions).map((c) => (
                      <option key={c}>{c}</option>
                    ))}
                    <option value="Others">Others</option>
                  </select>
                ) : (
                  <input
                    name="companyName"
                    placeholder="Enter your company name"
                    value={form.companyName}
                    onChange={handleChange}
                    required
                    autoFocus
                  />
                )}
              </div>

              <div className="form-group">
                <label>Company Logo</label>
                <input
                  type="file"
                  name="logo"
                  accept=".png,.jpg,.jpeg"
                  onChange={handleChange}
                />
                {form.logo && (
                  <img src={form.logo} alt="Preview" className="logo-preview" />
                )}
              </div>

              <div className="form-group">
                <label>Website</label>
                <input
                  type="url"
                  name="website"
                  value={form.website}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Industry</label>
                <select
                  name="industry"
                  value={form.industry}
                  onChange={handleChange}
                >
                  <option value="">Select Industry</option>
                  <option>IT Services</option>
                  <option>Education</option>
                  <option>Finance</option>
                  <option>Manufacturing</option>
                  <option>Healthcare</option>
                  <option>Others</option>
                </select>
              </div>

              <div className="form-group">
                <label>Company Description</label>
                <textarea
                  name="description"
                  rows="3"
                  value={form.description}
                  onChange={handleChange}
                ></textarea>
              </div>

              <div className="form-group">
                <label>Company Address</label>
                <input
                  name="address"
                  value={form.address}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>No. of Employees (optional)</label>
                <input
                  name="noOfEmployees"
                  value={form.noOfEmployees}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Your Designation (optional)</label>
                <input
                  name="designation"
                  value={form.designation}
                  onChange={handleChange}
                />
              </div>

              <div style={{ display: "flex", gap: "10px", marginTop: "1rem" }}>
                <button
                  type="button"
                  className="auth-btn back-btn"
                  onClick={handleBack}
                >
                  Back
                </button>
                <button type="submit" className="auth-btn">
                  Complete Registration
                </button>
              </div>
            </form>
          </>
        )}
      </div>

      {/* ✅ OTP MODAL */}
      {showOtpModal && (
        <div className="otp-overlay active">
          <div className="otp-modal">
            <h3>Verify Mobile Number</h3>

            <div className="otp-text-line">
              <p>
                We’ve sent an OTP to{" "}
                {isEditingPhone ? (
                  <input
                    type="tel"
                    name="phone"
                    value={form.phone}
                    onChange={handleChange}
                    className="edit-phone-input"
                  />
                ) : (
                  <strong>{form.phone}</strong>
                )}
              </p>
              <button
                className="edit-btn"
                onClick={() => setIsEditingPhone(!isEditingPhone)}
              >
                ✏️
              </button>
            </div>

            <div className="otp-input-container">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-${index}`}
                  type="text"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => handleOtpChange(e.target.value, index)}
                  className="otp-box"
                />
              ))}
            </div>
            {otpError && <p className="otp-error-text">{otpError}</p>}

            <button onClick={handleVerifyOtp} className="auth-btn">
              Verify OTP
            </button>

            <div className="resend-section">
              {resendDisabled ? (
                <p className="resend-timer" style={{ color: "red" }}>
                  Resend OTP in {timer}s
                </p>
              ) : (
                <p className="resend-line">
                  Didn’t receive OTP?{" "}
                  <span className="resend-link" onClick={handleResendOtp}>
                    Resend
                  </span>
                </p>
              )}
            </div>

            <button
              onClick={() => setShowOtpModal(false)}
              className="cancel-btn"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default RecruiterOnboarding;
